import { Box, Tooltip, Typography } from '@mui/material'
import { IconInfoCircle } from '@tabler/icons-react'
import { formatDate } from '~/utils'

export const NOT_MIGRATED_LABEL = 'ainda no padrão antigo'

export type InstallationNumberMigrationInfo = {
  oldInstallationNumber?: string | null
  installationNumberMigratedAt?: string | null
  hasNewStandardInstallationNumber?: boolean | null
}

export const isInstallationNumberMigrated = (info?: InstallationNumberMigrationInfo | null) => {
  return Boolean(info?.oldInstallationNumber)
}

export const installationNumberMigrationText = (info?: InstallationNumberMigrationInfo | null) => {
  if (!isInstallationNumberMigrated(info)) return NOT_MIGRATED_LABEL

  const migratedAt = info?.installationNumberMigratedAt ? formatDate(String(info.installationNumberMigratedAt)) : ''

  return migratedAt
    ? `Migrado em ${migratedAt} - número antigo: ${info?.oldInstallationNumber}`
    : `Número antigo: ${info?.oldInstallationNumber}`
}

const MigrationTooltipContent: React.FC<{ info?: InstallationNumberMigrationInfo | null }> = ({ info }) => {
  if (!isInstallationNumberMigrated(info)) {
    return <Typography fontSize='12px'>{NOT_MIGRATED_LABEL}</Typography>
  }

  const migratedAt = info?.installationNumberMigratedAt ? formatDate(String(info.installationNumberMigratedAt)) : null

  return (
    <Box>
      {migratedAt && <Typography fontSize='12px'>Migrado em {migratedAt}</Typography>}
      <Typography fontSize='12px'>Número antigo: {info?.oldInstallationNumber}</Typography>
    </Box>
  )
}

type InstallationNumberMigrationTooltipProps = {
  info?: InstallationNumberMigrationInfo | null
  children?: React.ReactElement
}

export const InstallationNumberMigrationTooltip: React.FC<InstallationNumberMigrationTooltipProps> = ({ info, children }) => {
  return (
    <Tooltip title={<MigrationTooltipContent info={info} />}>
      {children ?? (
        <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
          <IconInfoCircle size={24} color='#3BA1FF' />
        </Box>
      )}
    </Tooltip>
  )
}
